import { Component } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { Subscription } from 'rxjs'
import { productPromoCodeFilterModel } from '../../models/product-promo-code.model'
import { SharedService } from 'src/app/shared/services/shared.service'
import { environment } from 'src/environments/environment'
import { offersStatusEnum } from 'src/app/modules/products/models/product-promo-code.enum'
import { ActivatedRoute, Router } from '@angular/router'
import { productPromoCodeList } from 'src/app/modules/products/models/product-promo-code.model'
import { ProductsService } from '../../services/products.service'
import { ChangeDetectorRef } from '@angular/core'
import { FormControl, FormGroup } from '@angular/forms'

@Component({
	selector: 'app-product-promoCode-list',
	templateUrl: './product-promo-code-list.component.html',
	styleUrl: './product-promo-code-list.component.scss',
})
export class ProductPromoCodeListComponent {
	subscription = new Subscription()
	activeCountries!: any
	productPromoCodeFilter: productPromoCodeFilterModel = {
		StartDate: null,
		EndDate: null,
		ClientUsage: null,
		SearchText: '',
		ActiveTab: 0,
		Amount: null,

		countryId: 224,

		LabelStatus: [],
		promocodeTypes: [],
		paging: { pageNumber: 1, pageSize: 10 },
		ActivationStatus: [],
	}

	filterCount: number = 0
	offers!: productPromoCodeList[]
	attachmentUrl = environment.attachmentPath
	offerStatus = this.SharedService.returnEnumArray(offersStatusEnum)
	totalCount: number = 0
	filterForm: FormGroup = new FormGroup({})
	constructor(
		private SharedService: SharedService,
		public translate: TranslateService,
		private router: Router,
		public ActivatedRoute: ActivatedRoute,
		private ProductsService: ProductsService,
		private cd: ChangeDetectorRef
	) {
		{
			this.SharedService.headerTitle.next(`PRODUCT_PROMO.PRODUCT_PROMO`)
		}
	}
	ngOnInit() {
		this.getActiveCountries()
		this.subscription.add(
			this.ActivatedRoute.queryParams.subscribe((res) => {
				this.productPromoCodeFilter.countryId = res['country'] || 224
				this.productPromoCodeFilter.ActiveTab = res['ActiveTab'] || 0
				this.productPromoCodeFilter.paging.pageNumber = res['page'] || 1
				this.productPromoCodeFilter.paging.pageSize = res['count'] || 10
				this.productPromoCodeFilter.SearchText = res['SearchText'] || ''

				this.SharedService.handleBreadCrumb('product-promocode', true, {
					name: '',
					id: null,
					url: '/layout/store/products/product-promocode-list',
					queryParams: { ...res },
				})

				this.getProductPromoCodeList()
			})
		)
	}
	initForm() {
		this.filterForm = new FormGroup({
			startDate: new FormControl(this.productPromoCodeFilter.StartDate || null),
			endDate: new FormControl(this.productPromoCodeFilter.EndDate || null),
			Amount: new FormControl(this.productPromoCodeFilter.Amount || null),
			ClientUsage: new FormControl(
				this.productPromoCodeFilter.ClientUsage || null
			),
			LabelStatus: new FormControl(
				this.productPromoCodeFilter.LabelStatus || null
			),
			promocodeTypes: new FormControl(
				this.productPromoCodeFilter.promocodeTypes || null
			),
			countryId: new FormControl(this.productPromoCodeFilter.countryId || null),
		})
	}
	setFilterInUrl(filter: productPromoCodeFilterModel) {
		this.router.navigate(['/layout/store/products/product-promocode-list'], {
			queryParams: {
				StartDate: filter.StartDate,
				EndDate: filter.EndDate,
				ClientUsage: filter.ClientUsage,
				SearchText: filter.SearchText,
				ActiveTab: this.productPromoCodeFilter.ActiveTab,
				Amount: filter.Amount,
				countryId: this.productPromoCodeFilter.countryId,
				page: 1,
				count: 10,
			},
		})
	}
	getProductPromoCodeList() {
		this.subscription.add(
			this.ProductsService.getProductPromocodeList(
				this.productPromoCodeFilter
			).subscribe((res: any) => {
				this.offers = res.result.items
				this.totalCount = res.result.totalCount
			})
		)
	}
	getActiveCountries() {
		this.subscription.add(
			this.SharedService.getActiveCountries().subscribe((res: any) => {
				this.activeCountries = res
			})
		)
	}
	tapChanged(event: any) {
		this.router.navigate(['/layout/store/products/product-promocode-list'], {
			queryParams: {
				country: this.productPromoCodeFilter.countryId,
				ActiveTab: event,
			},
			queryParamsHandling: 'merge',
		})
	}
	countryChange(event: any) {
		this.router.navigate(['/layout/store/products/product-promocode-list'], {
			queryParams: {
				country: event,
			},
			queryParamsHandling: 'merge',
		})
	}
	searchTextChange(event: any) {
		this.router.navigate(['/layout/store/products/product-promocode-list'], {
			queryParams: {
				country: this.productPromoCodeFilter.countryId,
				ActiveTab: this.productPromoCodeFilter.ActiveTab,
				SearchText: event,
			},
			queryParamsHandling: 'merge',
		})
	}
	resetUrlParameters() {
		this.router.navigate(['/layout/store/products/product-promocode-list'], {
			queryParams: {
				countryId: this.productPromoCodeFilter.countryId,
				ActiveTab: this.productPromoCodeFilter.ActiveTab,
			},
		})
	}
	pagingChanged(pageNumber: number, pagecount: number) {
		this.router.navigate(['/layout/store/products/product-promocode-list'], {
			queryParams: {
				country: this.productPromoCodeFilter.countryId,
				status: this.productPromoCodeFilter.LabelStatus,
				page: pageNumber,
				count: pagecount,
			},
			queryParamsHandling: 'merge',
		})
	}

	FabNavigation() {
		this.router.navigate(['/layout/store/products/add-product-promocode'])
	}
	ngOnDestroy() {
		this.subscription.unsubscribe()
	}
}
